import React from 'react';
import {
    AUtableCaption,
    AUtableHeader,
    AUtableRow,
    AUtableBody,
    AUtableHead,
    AUtableCell
} from '@gov.au/table';
import PropTypes from 'prop-types';

/*
 * SimpleItemSummary
 *
 * @param  {string}    name                - name of the object in the row
 * @param  {array}     tableHeader         - table headers 
 * @param  {object}    tableBody           - table rows
 * @param  {function}  editUserCallback    - function for editing object in the row
 * @param  {function}  removeUserCallback  - function for editing object in the row
 * @param  {string}    caption             - title for the table
 */
export const SimpleItemSummary = ({ tableHeader, tableBody, caption, removeCallback, removeText }) => {

    const generateTableBody = () => {
        return (
            tableBody.map((item, index) => {
                return (
                    <SimpleItemSummaryRow
                        key={index}
                        tableHeader={tableHeader}
                        tableRowData={item}
                        removeCallback={removeCallback}
                        removeText={removeText}
                    />
                )
            })
        )
    }

    const generateTableHeader = (tableHeader, removeUserCallback) => {
        return (
            <AUtableRow>
                {
                    tableHeader.map(headerRow => {
                        return (
                            <AUtableHeader type="text" key={headerRow.key} title={headerRow.title} width={headerRow.width} />
                        )
                    })
                }
                {removeUserCallback !== undefined &&
                    <AUtableHeader type="text" title="" width="20" />
                }
            </AUtableRow>
        )
    }


    return (
        <table className="au-table au-table--striped simple-item-summary">
            <AUtableCaption tableCaption={caption} />
            <AUtableHead>
                {generateTableHeader(tableHeader, removeCallback)}
            </AUtableHead>
            {tableBody &&
                <AUtableBody>
                    {generateTableBody()}
                </AUtableBody>
            }
        </table>
    )
};

SimpleItemSummary.propTypes = {
    tableHeader: PropTypes.array.isRequired,
    tableBody: PropTypes.array.isRequired,
    editUserCallback: PropTypes.func,
    removeCallback: PropTypes.func,
    caption: PropTypes.string,
    removeText: PropTypes.string
};

/*
 * SimpleItemSummaryRow
 *
 * @param  {string}    name                - name of the object in the row
 * @param  {array}     tableHeader         - table headers 
 * @param  {object}    tableBody           - table rows
 * @param  {function}  editUserCallback    - function for editing object in the row
 * @param  {function}  removeUserCallback  - function for editing object in the row
 * @param  {string}    caption             - title for the table
 */
export const SimpleItemSummaryRow = ({ tableHeader, tableRowData, removeCallback, className, removeText }) => {
    const generateTableCells = () => {
        return (
            tableHeader.map((tableHeaderItem, key) => {
                if (tableHeaderItem.render) {
                    return <td key={key} className="au-table__cell">{tableHeaderItem.render(tableRowData[tableHeaderItem.key], tableRowData)}</td>
                }
                else {
                    return <AUtableCell key={key} data={tableRowData[tableHeaderItem.key]} type="text" />
                }
            })
        )
    }

    return (
        <AUtableRow className={className}>
            {generateTableCells()}
            {removeCallback !== undefined &&
                <td
                    className="au-table__cell"
                    key={"remove"}>
                    <a href="#" onClick={(e) => removeCallback(e)}>{removeText ?? "Remove"}</a>
                </td>}
        </AUtableRow>
    )
};

SimpleItemSummaryRow.propTypes = {
    className: PropTypes.string,
    tableHeader: PropTypes.array.isRequired,
    tableRowData: PropTypes.object.isRequired,
    removeCallback: PropTypes.func,
    removeText: PropTypes.string
};